enum EInstructionRemittanceAction {
  SEND = 'SEND',
  VIEW_DETAILS = 'VIEW-DETAILS',
  VIEW_OCCURRENCE = 'VIEW-OCCURRENCE',
  CHANGE_INSTRUCTION = 'CHANGE-INSTRUCTION',
}

export default EInstructionRemittanceAction;
